import React, { PureComponent } from 'react';
// import { NavLink } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import ClientCmp from '../../shared/components/clients/client-cmp';

export default class EditClientPage extends PureComponent {

  constructor() {
    super();
    this.state = {
      client_id: ''
    };
  }

  componentDidMount(){
    const { match } = this.props
    this.setState({client_id: (match && match.params) ? match.params.clientId : '' })
  }

  render(){
    return (<Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Client</h3>
        </Col>
        <Col md={12}>
          <ClientCmp editing={true} match={this.props.match} client_id={this.state.client_id} history={this.props.history}/>
        </Col>
      </Row>
    </Container>)
  }
}